/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteHotelMembershipRequest
 */
export interface FavoriteHotelMembershipRequest {
    /**
     * 
     * @type {Set<number>}
     * @memberof FavoriteHotelMembershipRequest
     */
    propertyIds: Set<number>;
}

/**
 * Check if a given object implements the FavoriteHotelMembershipRequest interface.
 */
export function instanceOfFavoriteHotelMembershipRequest(value: object): value is FavoriteHotelMembershipRequest {
    if (!('propertyIds' in value) || value['propertyIds'] === undefined) return false;
    return true;
}

export function FavoriteHotelMembershipRequestFromJSON(json: any): FavoriteHotelMembershipRequest {
    return FavoriteHotelMembershipRequestFromJSONTyped(json, false);
}

export function FavoriteHotelMembershipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteHotelMembershipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyIds': new Set(json['property_ids']),
    };
}

export function FavoriteHotelMembershipRequestToJSON(json: any): FavoriteHotelMembershipRequest {
    return FavoriteHotelMembershipRequestToJSONTyped(json, false);
}

export function FavoriteHotelMembershipRequestToJSONTyped(value?: FavoriteHotelMembershipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_ids': Array.from(value['propertyIds'] as Set<any>),
    };
}

